import type { FC, SVGProps } from 'react';
import { observer } from 'mobx-react-lite';
import Lottie from 'lottie-react';
import { Button } from '../../lib/ui/Button';
import { QuestionText } from '../QuestionText';
import type { LastPageModel } from './LastPageModel';
import ManWithStarsDefault from './man_with_stars.svg?react';
import ManWithStarsFirst from './man_with_stars_1.svg?react';
import ManWithStarsPremier from './man_with_stars_premier.svg?react';
import salut from './salute.json';
import styles from './LastPageView.module.scss';
import { appFactory } from '../../app/logic/AppFactory';
import { THEME_IDS } from '../../app/themes/types';

type SvgComponentType = FC<SVGProps<SVGSVGElement>>;

export const LastPageView: FC<{ questionModel: LastPageModel }> = observer(({ questionModel }) => {
  const { question, buttonProps, showSalute } = questionModel;

  const getManWithStarsImage = () => {
    const themeId = appFactory.app?.currentTheme?.id;
    const className = styles.LastPage_img;

    const themeToComponentMap: Record<string, SvgComponentType> = {
      [THEME_IDS.FIRST_THEME]: ManWithStarsPremier,
      [THEME_IDS.PREMIER_THEME]: ManWithStarsFirst
    };

    const Component: SvgComponentType = (themeId && themeToComponentMap[themeId]) || ManWithStarsDefault;

    return <Component className={className} data-testid="man-with-stars" />;
  };

  return (
    <>
      {getManWithStarsImage()}

      {showSalute && <Lottie animationData={salut} className={styles.Salute} loop={false} />}

      <QuestionText question={question} />

      <Button
        text={buttonProps.text || import.meta.env.VITE_SBER_LINK_TEXT}
        href={buttonProps.url || import.meta.env.VITE_SBER_LINK}
        isLink
        className={styles.LastPageButton}
      />
    </>
  );
});
